import { styled } from "sharedUI/styles";

export const DRMWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;

    > :last-child {
        min-height: 100px;
    }

    .margin-wrapper {
        margin-bottom: 16px;
    }
`;
